export interface RouteSeoMeta {
  title: string
  description: string
  canonicalPath: string
  keywords?: string
  noindex?: boolean
}

export const seoByRoute: Record<string, RouteSeoMeta> = {
  '/': {
    title: 'Chapterfour — медиа-продакшен полного цикла',
    description:
      'Коммерческое видео, реклама, дизайн, мобильная и web-разработка, графика, 3D motion. Медиа-продакшн полного цикла.',
    canonicalPath: '/',
    keywords:
      'медиапродакшен, видеопродакшен, коммерческое видео, реклама, motion дизайн, 3D motion, web разработка, mobile разработка, digital агентство, продакшен студия',
  },
  '/commercial': {
    title: 'Коммерческое видео',
    description:
      'Рекламные ролики, коммерческое видео и корпоративный контент. Видеопродакшен для брендов и бизнеса.',
    canonicalPath: '/commercial',
    keywords: 'коммерческое видео, рекламный ролик, видеореклама, видеопродакшен, реклама',
  },
  '/broadcast': {
    title: 'Broadcast и трансляции',
    description:
      'Телевизионный продакшен, прямые трансляции, стриминг. Broadcast-продакшен под ключ.',
    canonicalPath: '/broadcast',
    keywords: 'broadcast, трансляции, стриминг, телевизионный продакшен, прямая трансляция',
  },
  '/about': {
    title: 'Участники',
    description:
      'О медиа-продакшене Chapterfour: команда, подход, опыт. Коммерческое видео, реклама, дизайн, 3D motion.',
    canonicalPath: '/about',
    keywords: 'о студии, chapterfour, видеопродакшен, команда, медиа-продакшен',
  },
  '/3d': {
    title: '3D и Motion-дизайн',
    description: '3D-графика, motion-дизайн, визуальные эффекты. Реклама, тизеры, анимация.',
    canonicalPath: '/3d',
    keywords: '3D motion, motion дизайн, 3D графика, анимация, визуальные эффекты, VFX',
  },
  '/sound': {
    title: 'Звук и саунд-дизайн',
    description: 'Саунд-дизайн, озвучка, музыкальное оформление для видео и рекламы.',
    canonicalPath: '/sound',
    keywords: 'саунд-дизайн, озвучка, музыка для рекламы, звук для видео',
  },
  '/projects': {
    title: 'Проекты',
    description:
      'Портфолио Chapterfour: коммерческое видео, реклама, 3D, broadcast. Кейсы медиа-продакшена.',
    canonicalPath: '/projects',
    keywords: 'портфолио, кейсы, проекты, видеопродакшен, реклама',
  },
  '/contact': {
    title: 'Контакты',
    description:
      'Связаться с Chapterfour: заявка на видеопродакшен, рекламу, 3D и motion. Медиа-продакшен полного цикла.',
    canonicalPath: '/contact',
    keywords: 'контакты, заявка, chapterfour',
  },
  '/presentation': {
    title: 'Презентации',
    description: 'Презентации и статьи от Chapterfour: видеопродакшен, реклама, motion, digital.',
    canonicalPath: '/presentation',
  },
  '/policy': {
    title: 'Политика конфиденциальности',
    description: 'Политика конфиденциальности сайта Chapterfour.',
    canonicalPath: '/policy',
  },
  '/terms': {
    title: 'Пользовательское соглашение',
    description: 'Пользовательское соглашение сайта Chapterfour.',
    canonicalPath: '/terms',
  },
  '/test': {
    title: 'Тест',
    description: 'Тестовая страница.',
    canonicalPath: '/test',
    noindex: true,
  },
  '/develop': {
    title: 'Разработка',
    description:
      'Медиа-продакшн полного цикла: коммерческое видео, реклама, broadcast, 3D и motion. Chapterfour.',
    canonicalPath: '/develop',
    keywords: 'видеопродакшен, production, реклама, трансляции, 3D motion, медиа-продакшен',
  },
  '/kp': {
    title: 'Коммерческое предложение',
    description: 'Коммерческое предложение Chapterfour: видеопродакшен, реклама, 3D, broadcast.',
    canonicalPath: '/kp',
  },
}

const DEFAULT_SEO: RouteSeoMeta = {
  title: 'Chapterfour — медиа-продакшен полного цикла',
  description:
    'Коммерческое видео, реклама, дизайн, мобильная и web-разработка, графика, 3D motion.',
  canonicalPath: '/',
}

export function getSeoForPath(
  path: string,
  params: Record<string, string | string[]> = {},
): RouteSeoMeta {
  const exact = seoByRoute[path]
  if (exact) return { ...exact, canonicalPath: path }

  if (path.startsWith('/author/') && path.endsWith('/kp')) {
    const segments = path.replace(/^\/author\//, '').replace(/\/kp$/, '')
    const name = (params['name'] as string | undefined) ?? segments
    return {
      title: `Коммерческое предложение — ${name}`,
      description: `Персональное коммерческое предложение. Chapterfour.`,
      canonicalPath: path,
    }
  }

  if (path.startsWith('/author/')) {
    const name = (params['name'] as string | undefined) ?? path.replace(/^\/author\//, '')
    return {
      title: `Автор — ${name}`,
      description: `Профиль автора ${name} в Chapterfour. Медиа-продакшен, видеопродакшен.`,
      canonicalPath: path,
    }
  }

  if (path.startsWith('/project/')) {
    const id = (params['id'] as string | undefined) ?? path.replace('/project/', '')
    return {
      title: `Проект ${id}`,
      description: 'Проект медиа-продакшена Chapterfour: коммерческое видео, реклама, 3D motion.',
      canonicalPath: path,
    }
  }

  if (path.startsWith('/presentation/')) {
    return { title: 'Презентация', description: 'Презентация Chapterfour.', canonicalPath: path }
  }

  return { ...DEFAULT_SEO, canonicalPath: path }
}
